var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "md-field",
    { staticClass: "select", class: { "md-invalid": _vm.errors.length } },
    [
      _vm.label
        ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-select",
        _vm._b(
          {
            attrs: {
              value: _vm.value,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled
            },
            on: { input: _vm.onChange }
          },
          "md-select",
          _vm.inputProps,
          false
        ),
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.errors, function(error) {
        return _vm.errors.length
          ? _c("span", { staticClass: "md-error" }, [
              _vm._v("\n    " + _vm._s(_vm.$t(`errors.${error}`)) + "\n  ")
            ])
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }